import _ from 'underscore';
import React from 'react';
import amaze from '../assets/images/honda_amaze.png'
import indica_white from '../assets/images/indica_white.png'
import xcent_white from '../assets/images/xcent_white.png'
import tempo_traveller_white from '../assets/images/tempo_traveller_white.png'
import dzire_white from '../assets/images/dzire_white.png'
import ertiga_white from '../assets/images/ertiga_white.png'
import wagonr_white from '../assets/images/wagonr_white.png'

import '../styles/packages.css';

import PackageWidget from '../components/PackageWidget.js';

const packages = [
    {
        img: tempo_traveller_white,
        title: 'Tempo Traveller',
        price: '₹ 2500',
        hrsKms: '5 Hrs/50 Kms',
        acPrice: '₹ 2500',
        nonACPrice: '₹ 2000',
        driverBeta: '₹ 500',
        extraHrs: '₹ 150'
    },
    {
        img: wagonr_white,
        title: 'Suzuki Wagon R',
        price: '₹ 2200',
        hrsKms: '5 Hrs/50 Kms',
        acPrice: '₹ 2500',
        nonACPrice: '₹ 2000',
        driverBeta: '₹ 500',
        extraHrs: '₹ 150'
    },
    {
        img: ertiga_white,
        title: 'Suzuki Ertiga',
        price: '₹ 3500',
        hrsKms: '5 Hrs/50 Kms',
        acPrice: '₹ 2500',
        nonACPrice: '₹ 2000',
        driverBeta: '₹ 500',
        extraHrs: '₹ 150'
    },
    {
        img: indica_white,
        title: 'Tata Indica',
        price: '₹ 2000',
        hrsKms: '5 Hrs/50 Kms',
        acPrice: '₹ 2500',
        nonACPrice: '₹ 2000',
        driverBeta: '₹ 500',
        extraHrs: '₹ 150'
    },
    {
        img: xcent_white,
        title: 'Hyundai Xcent',
        price: '₹ 2300',
        hrsKms: '5 Hrs/50 Kms',
        acPrice: '₹ 2500',
        nonACPrice: '₹ 2000',
        driverBeta: '₹ 500',
        extraHrs: '₹ 150'
    },
    {
        img: dzire_white,
        title: 'Suzuki Swift',
        price: '₹ 2400',
        hrsKms: '5 Hrs/50 Kms',
        acPrice: '₹ 2500',
        nonACPrice: '₹ 2000',
        driverBeta: '₹ 500',
        extraHrs: '₹ 150'
    },
    {
        img: amaze,
        title: 'Honda Amaze',
        price: '₹ 2500',
        hrsKms: '5 Hrs/50 Kms',
        acPrice: '₹ 2500',
        nonACPrice: '₹ 2000',
        driverBeta: '₹ 500',
        extraHrs: '₹ 150'
    }
];

const Packages = () => {
    return (
        <div className="packages-container">
            {/* {_.shuffle(packages).map((item, index) => (
                    <div className="package" key={index}>
                        <img src={item.img} alt={item.title} />
                        <div className="info">
                            <h3>{item.title}</h3>
                            <p className="price">{item.price}<span>/Day</span></p>
                        </div>
                    </div>
                ))
            } */}
            {_.shuffle(packages).map((item, index) => (
                <PackageWidget pms={item} />))}
        </div>
    );
};

export default Packages;

